import { AppVersion } from './app-version';
import repositorySummary from './.repository-summary-placeholder-file.json';

export const constants = {
	repositorySummary,
	appVersion: new AppVersion(repositorySummary),
};
